'use es6';

import styled from 'styled-components';
import StyleProtectedSelectItem from '../style-protected/StyleProtectedSelectItem';
export default styled(StyleProtectedSelectItem).withConfig({
  displayName: "TextToolbarSelectOption",
  componentId: "sc-15tlz7p-0"
})(["font-size:13px !important;min-height:auto !important;padding:3px 6px !important;"]);